import * as types from '../mutation-types'

// state for the serial list component
const state = {
  search: '',
  selectCustomer: '',
  selectCity: '',
  selectCountry: ''
}

const getters = {
  search: state => state.search,
  selectCustomer: state => state.selectCustomer,
  selectCity: state => state.selectCity,
  selectCountry: state => state.selectCountry
}

const actions = {
}

const mutations = {
  [types.FILTER_SERIALS_SEARCH] (state, search) {
    state.search = search
  },
  [types.FILTER_SERIALS_SELECT_CUSTOMER] (state, customer) {
    state.selectCustomer = customer
  },
  [types.FILTER_SERIALS_SELECT_CITY] (state, city) {
    state.selectCity = city
  },
  [types.FILTER_SERIALS_SELECT_COUNTRY] (state, country) {
    state.selectCountry = country
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filterSerialList.js